import React from 'react';
import DismissIcon from './CustomIcons/DismissIcon';

interface SplitScreenLayoutProps {
    left: React.ReactNode;
    right: React.ReactNode;
    logo?: React.ReactNode;
    onClose?: () => void;
    footer?: React.ReactNode;
}

const CloseButton: React.FC<{ onClose: () => void; className?: string }> = ({
    onClose,
    className = '',
}) => (
    <button
        type="button"
        aria-label="Close"
        onClick={onClose}
        className={`flex cursor-pointer items-center justify-center border-0 bg-transparent p-0 transition-colors ${className}`}
    >
        <DismissIcon size={12} />
    </button>
);

const SplitScreenLayout: React.FC<SplitScreenLayoutProps> = ({
    left,
    right,
    logo,
    onClose,
    footer,
}) => (
    <div className="flex h-screen w-full overflow-hidden gap-3 bg-[var(--malachite-card-sunken-background)] p-3">
        <div className="flex min-w-0 flex-1 flex-col items-center px-[60px] py-[40px]">
            <div className="flex h-6 w-full shrink-0 items-center justify-between">
                <span className="size-6 shrink-0" aria-hidden />
                {logo ?? <span className="size-6 shrink-0" aria-hidden />}
                <span className="flex size-6 shrink-0 items-center justify-center">
                    {onClose ? (
                        <CloseButton
                            onClose={onClose}
                            className="text-[var(--malachite-text-secondary)] hover:text-[var(--malachite-text-primary)] lg:hidden"
                        />
                    ) : null}
                </span>
            </div>
            <div className="flex w-full min-h-0 flex-1 flex-col overflow-y-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
                <div className="m-auto flex w-full max-w-[380px] flex-col items-center py-10">
                    {left}
                </div>
            </div>
            <div className="flex h-6 shrink-0 items-center justify-center">{footer}</div>
        </div>
        <div className="relative hidden min-w-0 flex-1 flex-col items-center justify-center overflow-hidden rounded-[28px] bg-[#2b2b2b] px-[60px] py-[40px] lg:flex">
            {onClose ? (
                <CloseButton
                    onClose={onClose}
                    className="absolute top-[40px] right-[60px] z-10 text-white/70 hover:text-white"
                />
            ) : null}
            {right}
        </div>
    </div>
);

export default SplitScreenLayout;
